/* =====================================================
   KAEVRON LUXURY PACK V5
   Luxury JavaScript
===================================================== */

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header");

  if (!header) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 40) {
      header.classList.add("kaevron-scrolled");
    } else {
      header.classList.remove("kaevron-scrolled");
    }
  });
});
/* ==========================================
   KAEVRON V6.1
   Scroll Progress
========================================== */

document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("kaevron-progress")) {
    const bar = document.createElement("div");
    bar.id = "kaevron-progress";
    document.body.appendChild(bar);

    const updateProgress = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      bar.style.width = progress + "%";
    };

    window.addEventListener("scroll", updateProgress);
    updateProgress();
  }
});
/* ==========================================
   KAEVRON V6.2
   Luxury Interaction
========================================== */

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".card,.button,.header__menu-item").forEach((el) => {
    el.addEventListener("mouseenter", () => {
      el.style.transform = "translateY(-2px)";
    });

    el.addEventListener("mouseleave", () => {
      el.style.transform = "";
    });
  });
});